export const getMetricFromPickerDetails = (all, dets, fallback) => {
    const temp = JSON.parse(dets || '{}');
    return (
        all.find(
            m =>
                (temp.type === 'CRM' && temp.metricId === m.id && m.integration === 'CRM') ||
                (temp.type === m.ref && temp.metricId === m.id)
        ) || fallback
    );
};

export const benchmarkColour = (percent, reverse) => {
    const x = reverse ? 100 - percent : percent;
    return x >= 67 ? 'success' : x >= 34 ? 'warning' : 'danger';
};

export const quotaColour = percent => (percent >= 100 ? 'success' : percent >= 50 ? 'warning' : 'danger');

export const ratingColour = (rating, fallback = 'disabled') => {
    if (rating > 4) return 'success';
    if (rating > 3) return 'success-warning';
    if (rating > 2) return 'warning';
    if (rating > 1) return 'warning-danger';
    if (rating > 0) return 'danger';
    return fallback;
};
